export const VALID_COUNT_REGEX = /^(?:\d*|)$/;

export const MRP = "mrp";

export const OFFER_PRICE = "offerPrice";
